.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: var(--space-big);
}

@media screen and (width <= 990px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (width <= 675px) {
  .grid {
    grid-template-columns: repeat(1, 1fr);
  }
}

.isScrollable {
  --shadow-height: 500px;
}

.isScrollable>div {
  display: flex;
}

/*
.isScrollable>div>* {
  max-width: 33%;
  min-width: 33%;
  width: 33%;
} */


.isScrollable>div:nth-child(1)>* {
  max-width: max(300px, calc(33.33% - 2 * var(--space-medium)));
  min-width: max(300px, calc(33.33% - 2 * var(--space-medium)));
  width: 100%;
}